export class TaskSaveModel {
    constructor(
        public TareaId?:number,
        public ActuacionId?:number,
        public BajaId? : number,
        public Tipo? : number,
        public Fecha?:string,
        public Hora?:string,
        public FechaRegistro?:string,
        public Tarea1?:string,
        public Sme?:string,
        public Usuario?:string,
        public TipoAutor?:string,
        public Autor?: string,
        public Medico?: string,
        public MedicoId?:number,
        public TipoOperacion?:number,
        public EmpresaId?:number,
        public Comentario?:string,
    ){

    }
}